// extracted by mini-css-extract-plugin
module.exports = {"PersonList":"ComponentBodyPersonList_PersonList__JdmM3","Header":"ComponentBodyPersonList_Header__vpJEm"};